<section class="dialog-content">
	<ng-container class="d-flex align-items-center">
		<div class="margin-top-40 margin-bottom-10 text-20-bold text-align-center" dcrHTMLKey="CUSTOMIZE_BASELINE_DOLLAR_AMOUNT_TITLE">Customize Baseline Dollar Amount</div>

		<div class="margin-bottom-45 padding-horizontal-20 text-16 text-align-center" dcrHTMLKey="CUSTOMIZE_BASELINE_DOLLAR_AMOUNT_DESCRIPTION">
			Customize the baseline dollar amount of the portfolios in your analysis to calculate the dollar impact of selected scenarios. This baseline amount is only for use in
			Scenario Tester and will not affect the original dollar amounts of your portfolios.
		</div>

		<div class="user-input-field padding-horizontal-100 margin-bottom-85">
			<div class="aum-input-description text-12 pull-left" dcrHTMLKey="BASELINE_DOLLAR_AMOUNT">Baseline Dollar Amount</div>
			<div class="aum-input" [class.has-danger]="!isAumValid && !isAumEmpty">
				<p class="aum-dollar-sign text-16-bold">$</p>
				<input
					type="text"
					currency-input
					[symbolDisplay]="false"
					[digitDisplay]="'.0'"
					[class.form-control-danger]="!isAumValid && !isAumEmpty"
					[ngModel]="userInputAum"
					(ngModelChange)="onAumValueChange($event)"
				/>
			</div>
			<div *ngIf="!isAumValid && !isAumEmpty" class="form-control-feedback padding-top-10" dcrHTMLKey="CUSTOMIZE_BASELINE_DOLLAR_AMOUNT_ERROR_MESSAGE">
				Please enter a number greater than zero.
			</div>
			<div class="text-14" dcrHTMLKey="CUSTOMIZE_AMOUNT_PLACEHOLDER"></div>
		</div>
	</ng-container>

	<div class="d-flex align-items-center user-buttons-field padding-horizontal-20 margin-bottom-10">
		<button dz-button color="secondary" (click)="onCloseClick()">Cancel</button>
		<button dz-button [class.disabled]="!isAumValid || isAumEmpty" [disabled]="!isAumValid || isAumEmpty" (click)="onSaveClick()">Save</button>
	</div>
</section>
